import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel } from 'swiper/modules';
import styles from '@features/cms/components/collections/VisualBlock/VisualStickyBarLinks/VisualStickyBarLinks.styles';
import { ICmsDocument, IContentNavigation } from '@features/cms/typescript';
import Button from '@components/Button/Button';
import scrollToElementById from '@utils/scrollToElementById';
import 'swiper/css';
import 'swiper/css/free-mode';
type PropTypes = {
  subpages?: ICmsDocument[];
  categorySlug: string;
  activeSlug: string;
  hasProducts?: boolean;
  setNewActiveSlug: Dispatch<SetStateAction<string>> | undefined;
  contentNavigation: IContentNavigation[] | null;
};
const VisualStickyBarLinks = ({
  subpages = [],
  categorySlug,
  activeSlug,
  setNewActiveSlug,
  hasProducts = false,
  contentNavigation
}: PropTypes) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const changeActiveSlug = (slug: string) => {
    if (setNewActiveSlug) {
      setNewActiveSlug(slug);
    }
    const categoryPath = `/${categorySlug}/${slug}`;
    router.push(categoryPath, undefined, {
      scroll: false
    });
  };
  return <div sx={styles.stickyLinks}>
      <Swiper direction="horizontal" modules={[Mousewheel, FreeMode]} followFinger slidesPerView="auto" freeMode mousewheel>
        <SwiperSlide>
          <div sx={styles.stickyLinksContent}>
            {activeSlug === '' && contentNavigation && contentNavigation.length ? contentNavigation.map(link => <Button key={link.blockCode} variant="link" size="small" letterCase="uppercase" addSx={styles.linkButton(false)} onClick={() => scrollToElementById(link.blockCode)}>
                  {link.text}
                </Button>) : <Button variant="link" size="small" letterCase="uppercase" addSx={styles.linkButton(activeSlug === '')} onClick={() => changeActiveSlug('')}>
                {t('aboutCollection')}
              </Button>}

            {hasProducts && <Button variant="link" size="small" letterCase="uppercase" addSx={styles.linkButton(activeSlug === 'products')} onClick={() => changeActiveSlug('products')}>
                {t('products.all')}
              </Button>}

            {subpages.map(subpage => <Button key={subpage.id} variant="link" size="small" letterCase="uppercase" addSx={styles.linkButton(activeSlug === subpage.baseData?.slug)} onClick={() => changeActiveSlug(subpage.baseData?.slug as string)}>
                {subpage.baseData?.name}
              </Button>)}
          </div>
        </SwiperSlide>
      </Swiper>
    </div>;
};
export default VisualStickyBarLinks;